import { useRef } from 'react';

export const useHasValueChanged = <T>(value: T) => {
  const previousValue = useRef(value);
  const hasChanged = useRef(false);

  if (previousValue.current !== value) {
    previousValue.current = value;
    hasChanged.current = true;
  }

  return hasChanged.current;
};
